import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import {
  correspondenceQueryKeys,
  CorrespondenceThreadRoute,
} from "toptaal-shared"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { CorrespondenceEntityType } from "toptaal-shared"
import { checkPermissions } from "@/utils/checkPermissions"
import { can } from "@/utils/can"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/correspondentie/$threadId",
)({
  component: RouteComponent,
  beforeLoad: async () => {
    return checkPermissions("read", "groupCorrespondence")
  },
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useCurrentUserSuspenseQuery()
  const { groupId: groupIdParam, threadId: threadIdParam } = useParams({
    from: "/beheer/groepen/$groupId/correspondentie/$threadId",
  })
  const entityType: CorrespondenceEntityType = "LessonGroup"
  const threadId = Number(threadIdParam)
  const entityId = Number(groupIdParam)

  const handleNavigateBack = () => {
    router.navigate({
      to: `/beheer/groepen/${groupIdParam}/correspondentie`,
    })
  }

  return (
    <CorrespondenceThreadRoute
      threadId={threadId}
      entityType={entityType}
      entityId={entityId}
      user={user.data}
      correspondenceQueryKeys={correspondenceQueryKeys}
      onNavigateBack={handleNavigateBack}
      canCreateCorrespondence={can("create", "groupCorrespondence")}
    />
  )
}
